module.exports = "<div>\n  <ng-transclude></ng-transclude>\n\n  <a ng-show=\"shouldShowSwitch\" ng-click=\"switchAuthenticationMode()\" class=\"pull-right font-sm\">{{ isUsingGoogleTwoFactor ? 'You are using Google Authenticator. Use Transaction Password instead.' : 'You are using Transaction Password. Use Google Authenticator instead.'}}</a>\n</div>"


//////////////////
// WEBPACK FOOTER
// ./client/app/pages/customer/withdrawal/directive/switch-auth.html
// module id = 1431
// module chunks = 0